module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--7--b-2b2d0000.png";